var data_B = {
    name: '流程B',
    nodeList: [],
    lineList: []
}

export function getDataB() {
    return data_B
}



// WEBPACK FOOTER //
// ./src/components/ef/data_B.js